@if (loading) {
  <span [ngClass]="{'spinner-border-sm ml-3': !wrapClass}"
    class="spinner-border {{ wrapClass }}"
    role="status"
  aria-hidden="true"></span>
  <span class="sr-only">Loading...</span>
}
